// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { HistoryType } from '@shared/utils/History/HistoryType';
import { Level2CashItem } from './Level2CashItem';
export class QuoteSubscriptionItem {
    constructor(instrument, quoteCache) {
        this.listenerDict = new Map();
        this.lastQuoteDict = new Map();
        this.instrument = instrument;
        this.quoteCache = quoteCache;
        this.lvl2CashItem = new Level2CashItem(instrument, quoteCache);
        this.HasContinuousContractItem = false;
        this.InstrumentContinuousContractItem = null;
    }
    addListener(listener, quoteType) {
        if (isNullOrUndefined(listener === null || listener === void 0 ? void 0 : listener.newQuote) || quoteType === undefined) {
            throw new Error('arguments are undefined');
        }
        const arr = this.getListenerArray(quoteType);
        arr.push(listener);
        if (quoteType !== HistoryType.QUOTE_INSTRUMENT_DAY_BAR || isNullOrUndefined(this.instrument)) {
            const lastQuote = this.lastQuoteDict.get(quoteType);
            if (lastQuote) {
                listener.newQuote(lastQuote);
            }
        }
        else {
            const idms = this.instrument.GeneratedInstrumentDayBarMessages();
            for (const value of idms) {
                listener.newQuote(value);
            }
        }
    }
    removeListener(listener, quoteType) {
        if (!(listener === null || listener === void 0 ? void 0 : listener.newQuote) || quoteType === undefined) {
            throw new Error('arguments are undefined');
        }
        const arr = this.getListenerArray(quoteType);
        const idx = arr.indexOf(listener);
        if (idx >= 0) {
            arr.splice(idx, 1);
        }
    }
    getLastQuote(quoteType) {
        return this.lastQuoteDict.get(quoteType) || null;
    }
    getListenerArray(quoteType) {
        let arr = this.listenerDict.get(quoteType);
        if (isNullOrUndefined(arr)) {
            arr = [];
            this.listenerDict.set(quoteType, arr);
        }
        return arr;
    }
    getListenerCount(quoteType) {
        const listenerArr = this.getListenerArray(quoteType);
        return listenerArr.length;
    }
    newQuote(quote) {
        var _a, _b;
        const type = quote.Type;
        this.lastQuoteDict.set(type, quote);
        this.setTradingSessionForQuoteMessage(quote);
        (_a = this.instrument) === null || _a === void 0 ? void 0 : _a.newQuote(quote);
        if (type === HistoryType.QUOTE_LEVEL2) {
            (_b = this.lvl2CashItem) === null || _b === void 0 ? void 0 : _b.newQuote(quote);
        }
        for (const listener of this.getListenerArray(type)) {
            listener === null || listener === void 0 ? void 0 : listener.newQuote(quote);
        }
    }
    setTradingSessionForQuoteMessage(msg) {
        if (isNullOrUndefined(this.instrument)) {
            msg.TradingSession = null;
            return;
        }
        const currentSessionPeriod = this.instrument.Session.FindSessionPeriod(msg.cTime);
        if (currentSessionPeriod) {
            msg.SessionFlag = currentSessionPeriod.mainType;
        }
        msg.TradingSession = currentSessionPeriod;
    }
    dispose() {
        this.instrument = null;
        this.quoteCache = null;
        this.lvl2CashItem = null;
        this.listenerDict.clear();
        this.lastQuoteDict.clear();
    }
}
